import React from 'react';
import * as R from 'ramda';
import { Button } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

const COHORTS_WITH_STUDENT_PORTAL_BUTTON = ['685430ae896c45002b039818', '69721373b947e3906ebe4db2', '6985cc3cb947e3906ebe4dbc', '6985cd78b947e3906ebe4dbd'];

const StudentPortalButton = (props) => {
  const { record } = props;

  const isEnabled = R.includes(record.id, COHORTS_WITH_STUDENT_PORTAL_BUTTON);

  if (!isEnabled) return null;

  const url = 'https://learn.ironhack.com';
  return (
    <Button
      size="small"
      color="primary"
      target="_blank"
      variant="outlined"
      href={url}
    >
      <OpenInNew style={{ paddingRight: '0.2em' }} />
      Student Access
    </Button>
  );
};

export default StudentPortalButton;
